import Cookies from 'js-cookie'
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../types";
import { axiosClient } from "../../../api/axios-client";
import { ChatMessage } from "../types/chat-message";
import { sendMessageLogSubmission } from "./send-message-log";
import getMessageByVurablizeEvent from "../../../../application/utils/get-message-by-vurablize-event";
import VurbalizeEvents from "../../../types/dto/chat/vurbalize-events";
import { v4 } from "uuid";
import getCommonData from '../../../../application/utils/get-common-data';
import { MessageToServerPayload } from '../../../../application/contexts/chat-context';
import { ScheduleMeetingData } from '../../theme/types/schedule-meeting';

const getConversationSummary = (conversationId: any, messages: ChatMessage[]) => {
  if (!messages) return [];

  return messages
    .filter((message) => message.conversation_id === conversationId)
    .map((message) => ({
      conversation_id: message.conversation_id,
      itemType: message.itemType,
      value: message.value,
      turn_id: message.turn_id,
    }));
}

export const customCalendarEventScheduled = createAsyncThunk<
  void,
  {event: ScheduleMeetingData, sendMessageToServer: ((payload: MessageToServerPayload) => void) | null }
>('chat-slice/custom-calendar-event-scheduled',
  async ({ event, sendMessageToServer }, { getState, signal, rejectWithValue, fulfillWithValue, dispatch }) => {
    const state = getState() as RootState;

    const { conversationId } = state["app-state"];
    const { messages } = state.chat;
    let json_object = getConversationSummary(conversationId, messages);
    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.CUSTOM_CALENDAR_EVENT_SCHEDULED),
        event_name: VurbalizeEvents.CUSTOM_CALENDAR_EVENT_SCHEDULED,
        scheduled_by : event.name,
        turn_id: v4(),
      }
    }))

    const eventDetails = {
      name: event.name,
      email: event.email,
      message: event.message,
      addGuests: event.addGuests,
      guests: event.guests,
      selectedDate: event.selectedDate, 
      selectedTimeSlot: event.selectedTimeSlot, 
      selectedTimeZone: event.selectedTimeZone,
      agent_email: event.agent_email, 
      conversation_json: json_object,
    }

    const reqObj = {...getCommonData(state['app-state']), event_details: eventDetails};

    await axiosClient.post('/mail_conversation_summary', reqObj, { signal });

    if (sendMessageToServer) {
      sendMessageToServer({ message: 'Operator:[User has scheduled the call, thank the user]' })
    }
  }
)
